var React = require('react');

function IconInboundCall (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#a)","key":0},React.createElement("path",{"d":"M12.822 1.04 9.395 4.469h1.168c.337 0 .609.272.609.61 0 .337-.272.61-.61.61h-2.64a.608.608 0 0 1-.61-.61v-2.64c0-.339.272-.61.61-.61.338 0 .61.271.61.61v1.17l3.427-3.43a.61.61 0 0 1 .86.86l.003.003ZM2.983.036a1.012 1.012 0 0 1 1.204.59l1.016 2.437c.172.414.053.894-.295 1.175L3.656 5.263a8.581 8.581 0 0 0 4.08 4.08L8.76 8.092a1.013 1.013 0 0 1 1.175-.295l2.438 1.016c.472.195.724.71.589 1.203l-.61 2.235c-.119.442-.52.749-.977.749C5.093 13 0 7.906 0 1.625c0-.457.307-.859.749-.98l2.234-.61Z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fill":"#fff","d":"M0 0h13v13H0z"})))]);
}

IconInboundCall.defaultProps = {"fill":"currentColor","viewBox":"0 0 13 13"};

module.exports = IconInboundCall;

IconInboundCall.default = IconInboundCall;
